import { isMobileScreen } from '~/_shared/utils/deviceDetect/deviceDetect.helpers';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';
import { mapSettingsExportImageSettingsSelector } from '../../mapSettings/toolsState/exportImageSettings/exportImageSettings.selectors';

const deviceInfoScreenWidthSelector = (state: AppState) => state.frontendState.deviceInfo.screenWidth;
export const useDeviceInfoScreenWidthSelector = () => useSelector(deviceInfoScreenWidthSelector);

export const useIsMobileScreenSelector = () => {
  const screenWidth = useDeviceInfoScreenWidthSelector();
  const isExportMode = !!useSelector(mapSettingsExportImageSettingsSelector)?.mode;

  return isMobileScreen(screenWidth) && !isExportMode;
};
